export default {
  'menu.settings.workflow': '承認ワークフロー',
  'menu.settings.businessProcess': '業務プロセス設定',
  'menu.funds.operations': '基金资金与运营',
  'menu.funds.disclosure': '基金备案与信息披露',
  'menu.funds.distribution': '收益分配与清算',
  'menu.home.overview': '概览',
  'menu.funds.overview': '概览',
  'menu.investment.overview': '概览',
  'menu.portfolio.overview': '概览',
  'menu.research.overview': '概览',
  'menu.portfolio.exit.overview': '概览',

  'menu.settings.investmentFlow': '業務プロセスと承認設定',
  'menu.settings.fundDictionary': '基金业务字典',
  'menu.settings.portfolioConfig': '投后业务配置',
  'menu.settings.exitConfig': '退出业务配置',
  'menu.settings.researchConfig': '投研业务配置',

  'menu.analysis.fundPerformance': '基金业绩',
  'menu.analysis.portfolioAnalysis': '组合分析',
  'menu.analysis.investmentAnalysis': '投资项目分析',
  'menu.analysis.exitAnalysis': '退出回收分析',

  'menu.home.myWorkbench': '工作台',
  'menu.home.tasks': '待办与审批',
  'menu.home.focus': '关注对象',
  'menu.home.schedule': '日程安排',
  'menu.home.activity': '动态',
  'menu.home.risk': '风险与履约',
  'menu.home.LP 基金': 'LPファンド',
  'menu.home.基金协作': 'ファンド協業',
  'menu.analysis.overview': '概览',
  'menu.analysis.trace': '资金权益追溯',

  'menu.funds.总览': '总览',
  'menu.funds.基金': '基金',
  'menu.funds.基金.基金列表': '基金列表',
  'menu.funds.基金.投资联动': '投资联动',
  'menu.funds.基金.基金详情': '基金详情',
  'menu.funds.主体档案': '主体档案',
  'menu.funds.募资跟进': '募资跟进',
  'menu.funds.募资跟进.出资人跟进': '出资人跟进',
  'menu.funds.募资跟进.跟进详情': '跟进详情',
  'menu.funds.投资者关系': '投資家関係',
  'menu.funds.投资者关系.投资人关系': '投資家',
  'menu.funds.投资者关系.缴款台账': '払込台帳',
  'menu.funds.投资者关系.投资人详情': '投資家の詳細',
  'menu.funds.投资者关系.出资详情': '出資の詳細',
  'menu.funds.缴款与到账': '认缴与实缴',
  'menu.funds.出资详情': '出资详情',
  'menu.investment.概览': '概览',
  'menu.investment.项目线索': '资源池',
  'menu.investment.客户关系': '客户关系',
  'menu.investment.客户关系.客户': '客户',
  'menu.investment.客户关系.organizationDetail': 'organizationDetail',
  'menu.investment.客户关系.联系人': '联系人',
  'menu.investment.leadDetail': 'leadDetail',
  'menu.investment.投资项目': '投资项目',
  'menu.investment.projectDetail': 'projectDetail',
  'menu.investment.投资决策': '投资决策',
  'menu.investment.审批工作台': '审批工作台',
  'menu.investment.decisionDetail': 'decisionDetail',
  'menu.investment.交易与交割': '交易与交割',
  'menu.investment.transactionDetail': 'transactionDetail',
  'menu.investment.台账报表': '台帳レポート',
  'menu.portfolio.概览': '概览',
  'menu.portfolio.投后管理': '投后管理',
  'menu.portfolio.投后项目': '投后项目',
  'menu.portfolio.投后管理.全部项目': '全部项目',
  'menu.portfolio.投后管理.我的项目': '我的项目',
  'menu.portfolio.投后管理.投后项目详情': '投后项目详情',
  'menu.portfolio.经营跟踪': '经营跟踪',
  'menu.portfolio.经营跟踪.经营看板': '经营看板',
  'menu.portfolio.经营跟踪.数据记录': '数据记录',
  'menu.portfolio.经营跟踪.记录详情': '记录详情',
  'menu.portfolio.风险与事项': '风险与事项',
  'menu.portfolio.风险与事项.风险台账': '风险台账',
  'menu.portfolio.风险与事项.风险详情': '风险详情',
  'menu.portfolio.风险与事项.重点事项': '重点事项',
  'menu.portfolio.风险与事项.事项详情': '事项详情',
  'menu.portfolio.定期报告': '定期报告',
  'menu.portfolio.定期报告.报告列表': '报告列表',
  'menu.portfolio.定期报告.报告详情': '报告详情',
  'menu.portfolio.exit.退出机会': '退出机会',
  'menu.portfolio.exit.机会详情': '机会详情',
  'menu.portfolio.exit.退出项目': '退出项目',
  'menu.portfolio.exit.项目详情': '项目详情',
  'menu.portfolio.exit.退出交易': '退出交易',
  'menu.portfolio.exit.交易详情': '交易详情',
  'menu.research.工作台': '工作台',
  'menu.research.产业研究': '产业研究',
  'menu.research.产业研究.产业专题': '产业专题',
  'menu.research.产业研究.研究资料': '研究资料',
  'menu.research.企业与标的': '企业与标的',
  'menu.research.机构与专家资源': '机构与专家资源',
  'menu.research.机构与专家资源.投资机构': '投资机构',
  'menu.research.机构与专家资源.专家': '专家',
  'menu.research.机构与专家资源.FA与服务机构': 'FA与服务机构',
  'menu.research.课题管理': '课题管理',
  'menu.research.课题管理.研究课题': '研究课题',
  'menu.数据看板': '数据看板',
  'menu.系统设置': '系统设置',
  'menu.系统设置.业务设置': '业务设置',
  'menu.设置': '设置',
  'menu.设置.业务字典': '业务字典',
  'menu.设置.业务配置': '业务配置',
  'menu.客户关系': '客户关系',
  'menu.客户关系.客户': '客户',
  'menu.客户关系.客户详情': '客户详情',
  'menu.客户关系.联系人': '联系人',
  'menu.home': '工作台',
  'menu.funds': '基金与募资',
  'menu.investment': '投资项目',
  'menu.portfolio': '投后与退出',
  'menu.portfolio.exit': '退出管理',
  'menu.research': '投研与资源',
  'menu.analysis': '分析与报告',
  'menu.settings.platform': '平台配置',
  'menu.workbench': 'ようこそ',
  'menu.more-blocks': 'その他のブロック',
  'menu.workItem': 'マイタスク',
  'menu.schedule': 'スケジュール',
  'menu.focus': '重点フォロー',
  'menu.activity': '業務フォローと通知',
  'menu.overview': 'データ概要',
  'menu.sourceDetail': '業務詳細',
  'menu.admin': '管理者',
  'menu.admin.sub-page': 'サブページ',
  'menu.settings': 'システム設定',
  'menu.settings.permissions': '権限管理',
  'menu.settings.modelSettings': 'モデル設定',
  'menu.settings.dictionaries': '業務辞書',
  'menu.login': 'ログイン',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析',
  'menu.dashboard.monitor': 'モニター',
  'menu.dashboard.workplace': '職場',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（転送情報の書き込み）',
  'menu.form.step-form.confirm': 'ステップフォーム（転送情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完成）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': '基本リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト(記事)',
  'menu.list.search-list.projects': '検索リスト(プロジェクト)',
  'menu.list.search-list.applications': '検索リスト(アプリ)',
  'menu.profile': 'プロフィール',
  'menu.profile.basic': '基本プロフィール',
  'menu.profile.advanced': '高度なプロフィール',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.workbench': 'ワークベンチに戻る',
  'menu.account.tenantManagement': 'テナント管理',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',
  'menu.editor': 'グラフィックエディタ',
  'menu.editor.flow': 'フローエディタ',
  'menu.editor.mind': 'マインドエディター',
  'menu.editor.koni': 'コニエディター',
};
